import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="p-6 w-full min-h-screen mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-4">
        These Terms and Conditions govern your use of our services. By using our services, you agree to comply with these terms.
      </p>

      <h2 className="text-xl font-semibold mb-2">User Responsibilities</h2>
      <p className="mb-4">
        Users must provide accurate information and comply with all applicable laws. Any misuse of our services may result in account suspension.
      </p>

      <h2 className="text-xl font-semibold mb-2">Prohibited Activities</h2>
      <p className="mb-4">
        Users are prohibited from engaging in unlawful, harmful, or fraudulent activities while using our services.
      </p>

      <h2 className="text-xl font-semibold mb-2">Data Usage</h2>
      <p className="mb-4">
        We collect and store personal data as outlined in our Privacy Policy. By using our services, you consent to our data practices.
      </p>

      <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
      <p className="mb-4">
        We are not responsible for any damages resulting from your use of our services. Our liability is limited to the extent permitted by law.
      </p>

      <h2 className="text-xl font-semibold mb-2">Modifications to Terms</h2>
      <p className="mb-4">
        We reserve the right to modify these Terms and Conditions at any time. Continued use of our services constitutes acceptance of the updated terms.
      </p>

      <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
      <p>
        If you have any questions, please contact us at <strong>support@businessbasket.in </strong>.
      </p>
    </div>
  );
};

export default TermsAndConditions;
